import Patch from "@shared/models/patch-updater"

export const LESSON_CARD_INTERMEDIATE_UPDATE = {
  name: "LESSON_CARD_INTERMEDIATE_UPDATE",

  params: {
    value: { type: ["string", "boolean", "number"] },
    cardStackId: "string",
    prop: "string",
    sectionId: "string",
  },

  patches(payload) {
    let patch = Patch.create("card-stack", payload.cardStackId, "attributes.cards", {
      id: payload.sectionId,
    }).set("embedded", `attributes.${payload.prop}`, payload.value).patch

    return [patch]
  },

  undoPatches: null,

  narrative: null,
}
